<template>
  <div>
    <!--logo-->
    <div class='logo'>
      <img src='../../assets/images/logo.png'>
    </div>

    <template>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="首页" name="homePage">
          <div style='background-color: #bababa; width: 90%;height: 200px; margin: 20px auto'>
            <xg-player :url="videoUrl" @triggerEvent="triggerEvent" ></xg-player>
          </div>

          <!--视频列表-->
          <div class='videoTitle'>
            <p>
              <img src='../../assets/images/homePage/upArrow.png' @click="previousPage">
            </p>
            <ul>
              <li  v-for='item in homeVideoListData' :key='item.id' @click="videoOnClick(item)" v-bind:class='{actived:item==isactive}'>
                {{ item.name }}
              </li>
            </ul>
            <p>
              <img src='../../assets/images/homePage/downArrow.png' @click="nextPage">
            </p>
          </div>

        </el-tab-pane>
        <el-tab-pane label="主营业务" name="mainBusiness">主营业务

        </el-tab-pane>

        <el-tab-pane label="经典案例" name="case">经典案例</el-tab-pane>
        <el-tab-pane label="新闻中心" name="newsCenter">新闻中心</el-tab-pane>
        <el-tab-pane label="研究院" name="researchInstitute">研究院</el-tab-pane>
        <el-tab-pane label="关于埃文" name="avi">关于埃文</el-tab-pane>
      </el-tabs>
      <!--底部占位-->
      <div style='height: 80px;'>
      </div>
    </template>

    <!--底部选项卡-->
    <div class='bottom'>
      <ul>
        <li class='tab' @click="tabButton(1)">联系方式</li>
        <li class='tab' @click="tabButton(2)">加入低碳行业</li>
        <li class='tab' @click="tabButton(3)">合作网站</li>
      </ul>
      <p>企业节能减排与低碳发展综合解决方案提供商</p>
    </div>
  </div>
</template>

<script >
import homePage from './homePage.vue'
import mainBusiness from './mainBusiness.vue'
import trainingCenter from './trainingCenter.vue'
import newsCenter from './newsCenter.vue'
import customerStories from './customerStories.vue'
import aboutAvi from './aboutAvi.vue'
import platformPartners from './platformPartners.vue'
import footer from './footer.vue'
import expert from './expert.vue'
import Player from 'xgplayer'
import XgPlayer from '@/components/XgPlayer'

import { selectConfig, selectVideo } from '../../api/auth'

export default {
  provide () {
    return {
      say: this.say,
      activeName: 'second'
    }
  },
  components: {
    XgPlayer
  },

  created () {
    if (this.$route.query.type != null) {
      this.sayDetailed(this.$route.query.type)
    }
    this.webConfig()
    this.selectVideo(1)
    this.$nextTick(function () {
      if (this.$route.query.type != null) {
        this.sayDetailed(this.$route.query.type)
      }
      // else if (this.$router.query.raw != null) {
      //   this.sayDetailed(this.$route.query.raw)
      // } else {
      //
      // }
    })
  },
  props: {
    srcList: {
    }
  },

  data () {
    return {
      videoOptions: {
        autoplay: true,
        controls: true,
        sources: [
          {
            src: 'http://vjs.zencdn.net/v/oceans.mp4',
            type: 'video/mp4'
          }
        ]
      },
      isactive: null,
      input1: '',
      isDialog: true,
      activeName: 'homePage',
      isChildUpdate1: true,
      isChildUpdate2: false,
      isChildUpdate3: false,
      isChildUpdate4: false,
      isChildUpdate5: false,
      isChildUpdate6: false,
      isChildUpdate7: false,
      homeVideoListData: [],
      // 视频链接支持https或require本地地址
      videoUrl: '',
      //  videoUrl: require('../../assets/11111.mp4'),
      // 视频封面支持https或require本地地址
      videoCover: require('../../assets/images/bmp.jpg'),
      queryVideoParams: {
        pageNum: 1,
        pageSize: 6
      },
      // 总条数
      total: 0,
      // 总页数
      pages: 0,
      currentPage: 1,
      tableData: {
        legacyPortal: ''
      },
      queryParams: {
      },
      player: null,
      components: {
        child0: homePage,
        child1: mainBusiness,
        child2: trainingCenter,
        child3: newsCenter,
        child4: aboutAvi,
        child5: customerStories,
        child7: platformPartners,
        child8: expert,
        tail: footer
      }
    }
  },
  mounted () {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL) // 这里有没有都无所谓，最好是有以防万一
      window.addEventListener('popstate', this.goBack, false) // 回退时执行goback方法
    }
  },
  destroyed () {
    window.removeEventListener('popstate', this.goBack, false)
  },
  methods: {
    nextPage () {
      if (this.currentPage < this.pages) {
        this.currentPage++
        this.selectVideo(this.currentPage)
      }
    },
    previousPage () {
      if (this.currentPage > 1) {
        this.currentPage--
        this.selectVideo(this.currentPage)
      }
    },
    tabButton (raw) {
      if (raw === 1) {
        // 联系方式
        this.$router.push({
          path: '/mobileContacInformation',
          query: {}
        })
      } else if (raw === 2) {
        // 加入低碳
        this.$router.push({
          path: '/moblielowCarbonIndustry',
          query: {}
        })
      } else if (raw === 3) {
        // 合作伙伴
        this.$router.push({
          path: '/mobileCooperativePartner',
          query: {}
        })
      }
    },
    // 监听到子组件传过来的播放状态 true是播放 false是暂停
    triggerEvent (value) {
      console.log('是否播放：', value)
    },
    init () {
      this.$nextTick(() => {
        this.player = new Player({
          id: 'mse',
          url: this.videoUrl,
          poster: require('../../assets/images/bmp.jpg')
        })
      })
    },
    goBack () {
      window.location.reload()
    },
    /** 查询视频 */
    selectVideo (raw) {
      let that = this
      this.queryVideoParams.pageNum = raw
      selectVideo(this.queryVideoParams).then(res => {
        that.homeVideoListData = res.records
        this.total = res.total
        this.pages = res.pages
        if (that.homeVideoListData && that.homeVideoListData.length > 0) {
          that.videoUrl = that.homeVideoListData[0].videoUrl
          this.init()
        } else {
        }
      })

      // eslint-disable-next-line no-unused-vars
    },
    videoOnClick (raw) {
      this.isactive = raw
      this.videoUrl = raw.videoUrl
      if (this.player === null) {
        this.player = new Player({
          id: 'mse',
          url: this.videoUrl,
          poster: '../../assets/images/logo.png'
        })
      } else {
        this.player.url = this.videoUrl
      }
    },
    skipHome (raw) {
      // if (window.location.href.indexOf('#reloaded') === -1) {
      //   window.location.href = window.location.href + '#reloaded'
      //   window.location.reload()
      // }
      this.$router.push({
        path: '/mobileIndex'
      })
      window.location.reload()
    },
    /** 查询网站配置 */
    webConfig () {
      let that = this
      selectConfig(this.queryParams).then(res => {
        that.tableData.legacyPortal = res.legacyPortal
      })
    },
    handleClick (tab, event) {
      if (tab.name === 'homePage') {
        this.$router.push({
          path: '/mobileIndex',
          query: {
          }
        })
      } else if (tab.name === 'mainBusiness') {
        this.$router.push({
          path: '/mobileMainBusiness',
          query: {
          }
        })
      } else if (tab.name === 'case') {
        this.$router.push({
          path: '/mobileCase',
          query: {
          }
        })
      } else if (tab.name === 'researchInstitute') {
        this.$router.push({
          path: '/mobileResearchInstituter',
          query: {
          }
        })
      } else if (tab.name === 'avi') {
        this.$router.push({
          path: '/mobileAboutAvi',
          query: {
          }
        })
      } else if (tab.name === 'newsCenter') {
        this.$router.push({
          path: '/mobileNewsCenter',
          query: {
          }
        })
      }
    },
    // tabs切换拦截
    beforeTabLeave (newIndex, oldIndex) {
      if (newIndex === 'fourth') {
        return false
      } else {
        return true
      }
    },
    sayDetailed (raw) {
      if (raw === 'homePage') {
        this.isDialog = true
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = true
        this.activeName = 'homePage'
      } else if (raw === 'mainBusiness') {
        this.isDialog = false
        this.activeName = 'mainBusiness'
        localStorage.setItem('mainBusinessType', 'first')
        this.isChildUpdate2 = true
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
      } else if (raw === 'customerStories') {
        this.isDialog = false
        this.isChildUpdate2 = false
        this.activeName = 'customerStories'
        this.isChildUpdate3 = true
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
      } else if (raw === 'newsCenter') {
        this.isDialog = false
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.activeName = 'newsCenter'
        this.isChildUpdate4 = true
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('newsCenter', 'journalism')
      } else if (raw === 'trainingCenter') {
        this.isDialog = false
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
        this.activeName = 'trainingCenter'
        this.isChildUpdate5 = true
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
      } else if (raw === 'aboutAvi') {
        this.isDialog = false
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.activeName = 'aboutAvi'
        this.isChildUpdate6 = true
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
      } else if (raw === 'journalism') {
        this.isDialog = false
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.activeName = 'newsCenter'
        this.isChildUpdate4 = true
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('newsCenter', 'journalism')
      } else if (raw === 'industry') {
        this.isDialog = false
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.activeName = 'newsCenter'
        this.isChildUpdate4 = true
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('newsCenter', 'industry')
      } else if (raw === 'avi') {
        this.isDialog = false
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.activeName = 'newsCenter'
        this.isChildUpdate4 = true
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('newsCenter', 'avi')
      } else if (raw === 'first') {
        this.isDialog = false
        this.isChildUpdate2 = false
        this.isChildUpdate3 = true
        this.activeName = 'customerStories'
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('customerStories', 'first')
      } else if (raw === 'second') {
        this.isDialog = false
        this.isChildUpdate2 = false
        this.isChildUpdate3 = true
        this.activeName = 'customerStories'
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('customerStories', 'second')
      }
    },
    say (raw) {
      this.isDialog = false
      if (raw === '温室气体排放清单' || raw === '农林低碳发展' || raw === '政府发展规划' || raw === '生态文明建设' ||
        raw === '碳达峰时间预测和分析' || raw === '碳达峰碳中和科普与政策解读' || raw === '碳排放管理培训' || raw === '低碳试点建设' ||
        raw === '碳盘查' || raw === '节能与循环经济') {
        this.activeName = 'mainBusiness'
        this.isChildUpdate2 = true
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('mainBusinessType', 'first')
      } else if (raw === '企业碳管理咨询' || raw === '碳资产开发咨询' || raw === '绿色供应链标识服务' || raw === '环保咨询' ||
        raw === '碳达峰碳中和路径分析' || raw === '碳足迹咨询服务' || raw === '节能减排咨询' || raw === '绿色建筑评价报告' ||
        raw === '碳排放管理培训') {
        this.activeName = 'mainBusiness'
        this.isChildUpdate2 = true
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('mainBusinessType', 'second')
      } else if (raw === '智慧碳表') {
        this.activeName = 'mainBusiness'
        this.isChildUpdate2 = true
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('mainBusinessType', 'third')
      } else if (raw === '更多新闻') {
        this.activeName = 'newsCenter'
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.isChildUpdate4 = true
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('newsCenter', 'journalism')
      } else if (raw === '更多资讯') {
        this.activeName = 'newsCenter'
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.isChildUpdate4 = true
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('newsCenter', 'industry')
      } else if (raw === '更多观点') {
        this.activeName = 'newsCenter'
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.isChildUpdate4 = true
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('newsCenter', 'avi')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.el-row {
  &:last-child {
    margin-bottom: 0;
  }
}

//logo
.logo{
  img{
    width: 70%;
    display: block;
    margin:10px auto;
  }
}

//tabs样式
::v-deep .el-tabs__item {
  border: 1px solid #fff;
  background-color: #90bc4f;
  width: 33.33%;
  font-size: 14px;
  color: #fff;
  height: 40px;
  line-height: 40px;
  float: left;
  display: block;
  text-align: center;
}
::v-deep .el-tabs__item.is-active {
  color: #fff;
  background-color: #73b649;
}
::v-deep .el-tabs__item.is-top:nth-child(2) {
   padding-left: 20px;
 }
::v-deep .el-tabs__item.is-top:nth-child(7) {
  padding-left: 0px;
}

.videoTitle{
  height: 300px;
  width: 90%;
  margin: 0 auto;
  p{
    height: 30px;
    width: 100%;
    background: url("../../assets/images/homePage/edge1.png") center  center no-repeat;
    img{
      display: block;
      margin: 0 auto;
      cursor:pointer;
      height: 28px;
      width: 28px;
    }
  }
  ul{
    height: 240px;
    li{
      width: 100%;
      height: 40px;
      line-height: 40px;
      font-size: 18px;
      font-family: SourceHanSansSC;
      overflow: hidden; /*内容会被修剪，并且其余内容是不可见的*/
      text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本。*/
      white-space: nowrap; /*文本不换行*/
      cursor:pointer;
    }
    .actived {
      color: #307a02;
      font-family: "微软雅黑";
      }
  }
}
.videoPlayer {
  height: 300px;
  width: 200px;
  margin: 0 auto;
}
//底部选项卡
.bottom{
  background-color: #fff;
  height: 80px;
  width: 100%;
  position: fixed;
  bottom: 0;
  .tab{
    width: 33.33%;
    float: left;
    text-align: center;
    background-color: #90bc4f;
    border: 1px solid #fff;
    font-size: 14px;
    color: #fff;
    height: 40px;
    line-height: 40px;
  }
  p{
    font-size: 14px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    color:#90bc4f;
  }
}
::v-deep .el-tab-pane{
  height:620px;
}
::v-deep .el-tabs__nav{
  width: 100%;
}
//去掉tab下划线
::v-deep .el-tabs__active-bar {
  width: 0px !important;
}
</style>
